import { Location } from '@angular/common';
import { Component, Inject, Input, inject } from '@angular/core';
import { MessageCount, MessageService } from '@nano/common/message';
import { RoutingService } from '@nano/common/routing';
import { RoutePath } from '@nano/common/routing/routing';
import { CONFIG } from '@nano/core/config';
import { UntilDestroy } from '@ngneat/until-destroy';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { Observable } from 'rxjs';
import { NavService } from './nav.service';

@UntilDestroy()
@Component({
  selector: 'app-nav',
  templateUrl: 'nav.component.html',
  styleUrls: ['nav.component.less'],
  standalone: false
})
export class NavComponent {
  @Input() visible: boolean;

  readonly messageCount$: Observable<MessageCount>;
  readonly cardMenuVisible$: Observable<boolean>;
  readonly ebanksisLoansMenuVisible$: Observable<boolean>;
  readonly loansMenuVisible$: Observable<boolean>;
  readonly cardMenuEnabled$: Observable<boolean>;
  readonly pendingOperationsCount$: Observable<number>;
  private loansApplicationUrl: string;
  private logoLinkAuthorized: string;

  mobileMenuDrawerWidth: string;
  mobileMenuDrawerVisible: boolean;

  private config = inject(CONFIG);

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private location: Location,
    private messageService: MessageService,
    private routingService: RoutingService,
    private navService: NavService
  ) {
    this.messageCount$ = this.messageService.messageCount$;

    this.loansApplicationUrl = this.config.loansApplicationUrl;
    this.logoLinkAuthorized = this.config.logoLinkAuthorized;

    this.cardMenuVisible$ = this.navService.cardMenuVisible$;
    this.cardMenuEnabled$ = this.navService.cardsEnabled$;
    this.ebanksisLoansMenuVisible$ = this.navService.ebanksisLoansEnabled$;
    this.loansMenuVisible$ = this.navService.loansEnabled$;
    this.pendingOperationsCount$ = this.navService.pendingOperationsCount$;
  }

  get accountsMenuSelected(): boolean {
    return this.location.path().includes(RoutePath.accounts) && !this.location.path().includes(RoutePath.settings);
  }

  get cardsMenuSelected(): boolean {
    return this.location.path().includes(RoutePath.cards);
  }

  get loansMenuSelected(): boolean {
    return this.location.path().includes(RoutePath.loans);
  }

  openMobileMenuDrawer(): void {
    this.mobileMenuDrawerVisible = true;
  }

  closeMobileMenuDrawer(): void {
    this.mobileMenuDrawerVisible = false;
  }

  logoClicked(): void {
    this.closeMobileMenuDrawer();
    if (this.logoLinkAuthorized) {
      window.location.href = this.logoLinkAuthorized;
    } else {
      this.routingService.navigateToRoot();
    }
  }

  navigateToAccounts(): void {
    this.closeMobileMenuDrawer();
    this.routingService.navigateToRoot();
  }

  navigateToCards(): void {
    this.closeMobileMenuDrawer();
    this.routingService.navigateToCards();
  }

  navigateToLoans(): void {
    window.open(this.loansApplicationUrl, '_blank');
  }

  navigateToLoansPreview(): void {
    this.closeMobileMenuDrawer();
    this.routingService.navigateToLoans();
  }

  navigateToMessages(): void {
    this.closeMobileMenuDrawer();
    this.routingService.navigateToMessages();
  }
}
